import { LoadingService } from './../../../services/loading.service';
import { BookingService } from 'src/app/services/booking.service';
import { Component, EventEmitter, Output, OnInit, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Customer } from 'src/app/models/Customer';
import { AuthService } from 'src/app/services/auth.service';
import { SearchCountryField, TooltipLabel, CountryISO } from 'ngx-intl-tel-input';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';

@Component({
  selector: 'driver-update',
  templateUrl: './driver-update.component.html',
  styleUrls: ['./driver-update.component.scss']
})
export class DriverUpdateComponent implements OnInit {

  faTimesCircle=faTimesCircle;
  @Output() onCancel = new EventEmitter();
  //@Input() driverData:any;

  @Output() onDriverUpdated = new EventEmitter();
  driverInfoForm: FormGroup;
  submitted = false;
  customer: Customer;
  minDOB:Date=new Date();

  constructor(private formBuilder: FormBuilder
    , private authService: AuthService
    , private bookingService: BookingService
    , private loadingService: LoadingService,
    private dialog: MatDialog,
    private domSanitizer: DomSanitizer,
    //private dialogRef: MatDialogRef<DriverUpdateComponent>,
  ) {
      this.minDOB.setFullYear( this.minDOB.getFullYear() - 18 );
  }

  ngOnInit() {


    this.authService.loggedInCustomer.subscribe(res => {

      if (res != null) {
        this.customer = res;
        this.initlizeForm({
          firstName: res.firstName,
          secondName: res.secondName,
          thirdName: res.familyName,
          DateofBirth: res.dob,
          email: res.primaryEmail,
          mobileNum: res.mobile1
        })
      }
      else {
        let _cachedCustomer = JSON.parse(this.authService.GetCustomerStorage());
        if (_cachedCustomer != null) {
          this.authService.saveCustomer(_cachedCustomer);

        }
        //Here should be logged in
        //No default value initalization
        else {
          this.initlizeForm({
            firstName: '',
            secondName: '',
            thirdName: '',
            DateofBirth: '',
            email: '',
            mobileNum: ''
          });
        }

      }
    });


  }

  initlizeForm(model) {
    this.driverInfoForm = this.formBuilder.group({
      firstName: [model.firstName, Validators.required],
      secondName: [model.secondName, Validators.required],
      thirdName: [model.thirdName, Validators.required],
      DateofBirth: [model.DateofBirth, Validators.required],
      email: [model.email, [Validators.required, Validators.email]],
      mobileNum: [model.mobileNum, Validators.required],
    });
  }

  // convenience getter for easy access to form fields
  get driverInfo() { return this.driverInfoForm.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.driverInfoForm.invalid) {
      return;
    }

    let customer = this.fetchCustomerFromForm();


    setTimeout(() => {
      this.loadingService.updateLoadingState(true);
    });

    this.bookingService.updateCustomer(customer).subscribe(res => {
      this.authService.saveCustomer(customer);
      this.onDriverUpdated.emit(true);
      this.onCancel.emit(true);
      this.ngOnDestroy();
      this.loadingService.updateLoadingState(false);
    });

  }
  fetchCustomerFromForm() {

    //Deep Copy for Customer
    //To Prevent two way changing in non-related component
    let customer = null;
    customer = Object.assign({}, customer, this.customer);
    customer.firstName = this.driverInfoForm.controls['firstName'].value;
    customer.secondName = this.driverInfoForm.controls['secondName'].value;
    customer.familyName = this.driverInfoForm.controls['thirdName'].value;
    customer.dob = this.driverInfoForm.controls['DateofBirth'].value;
    customer.mobile1 = this.driverInfoForm.controls['mobileNum'].value.number;
    customer.primaryEmail = this.driverInfoForm.controls['email'].value;
    return customer;
  }

  onReset() {
    this.submitted = false;
    this.driverInfoForm.reset();
  }

  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  phoneForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required])
  });

  changePreferredCountries() {
    this.preferredCountries = [CountryISO.India, CountryISO.Canada];
  }

  close(): void {
    //this.dialogRef.close();
  }



  cancelClicked() {
    this.onCancel.emit(true);
    this.ngOnDestroy();
  }

  ngOnDestroy(): void { }

}
